import { User } from '@angular/fire/auth';
import { AuthPipe } from '@angular/fire/auth-guard';
import { pipe, map, switchMap, of } from 'rxjs';

const idTokenResult = switchMap((user: User | null) =>
  user ? user.getIdTokenResult() : of(null),
);
const customClaims = pipe(
  idTokenResult,
  map((idTokenResult) => (idTokenResult ? idTokenResult.claims : [])),
);
export const hasCustomClaimRedirect: (
  claim: string | string[],
  redirect: string,
) => AuthPipe = (claim, redirect) =>
    pipe(
      customClaims,
      map((claims) =>
        Array.isArray(claim)
          ? claim.some((c) => claims.hasOwnProperty(c))
          : claims.hasOwnProperty(claim),
      ),
      map((hasClaim) => hasClaim || redirect), // Redirect to onboarding if the claim is not present
    );

// Ethikrat member guard - redirects to application page if not a member
export const isEthikratMember = () =>
  hasCustomClaimRedirect('ethikrat_member', '/dashboard/ethikrat/application');